import React, { useState } from "react";
import axios from "axios";

function ContactForm() {
  const [formData, setFormData] = useState({
    contact_names: "",
    contact_email: "",
    contact_phone: "",
    contact_message: "",
  });
  const [error, setError] = useState({});
  const [success, setSuccess] = useState(false);
  const [apiError, setApiError] = useState("");
  const [validationError, setValidationError] = useState("");
  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    // For phone number, only allow digits, +, spaces, dashes, parentheses, and dots
    if (name === "contact_phone") {
      const filteredValue = value.replace(/[^0-9+\s\-().]/g, "");
      setFormData({ ...formData, [name]: filteredValue });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    setError({ ...error, [name]: "" });
    setApiError("");
    setValidationError("");
  };

  // Validate form
  const validateForm = () => {
    let errors = {};

    // Validate Full Name
    if (!formData.contact_names.trim()) {
      errors.contact_names = "Full Name is required";
    } else if (formData.contact_names.trim().length < 2) {
      errors.contact_names = "Full Name must be at least 2 characters";
    }

    // Validate Email
    if (!formData.contact_email.trim()) {
      errors.contact_email = "Email Address is required";
    } else {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(formData.contact_email.trim())) {
        errors.contact_email =
          "Please enter a valid email address (e.g., user@example.com)";
      }
    }

    // Validate Phone Number - International format
    if (!formData.contact_phone.trim()) {
      errors.contact_phone = "Phone Number is required";
    } else {
      // Remove spaces, dashes, parentheses, and dots for validation
      const cleanPhone = formData.contact_phone.replace(/[\s\-().]/g, "");
      // Accept numbers with optional + prefix, minimum 7 digits, maximum 15 digits (international standard)
      const phoneRegex = /^(\+)?\d{7,15}$/;
      if (!phoneRegex.test(cleanPhone)) {
        errors.contact_phone =
          "Please enter a valid phone number (7-15 digits, optional + prefix)";
      }
    }

    // Validate Message
    if (!formData.contact_message.trim()) {
      errors.contact_message = "Message is required";
    } else if (formData.contact_message.trim().length < 10) {
      errors.contact_message = "Message must be at least 10 characters";
    }

    return errors;
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setError(errors);
      // Set the first error message to display in alert
      const firstError = Object.values(errors)[0];
      setValidationError(firstError);
      return;
    }

    setLoading(true);
    setApiError("");
    setValidationError("");
    setSuccess(false);
    try {
      const response = await axios.post(
        "https://emails.foipin.com/email/send_mail",
        {
          mail_templateID: 5,
          user_email: formData.contact_email.trim(),
          user_name: formData.contact_names.trim(),
          user_phone: formData.contact_phone.trim(),
          user_message: formData.contact_message.trim(),
        }
      );

      // Check if response indicates an error
      if (
        response.data &&
        response.data.result &&
        response.data.result.status === "ERR"
      ) {
        setApiError(
          "We couldn't send your message. Please check your information and try again."
        );
      } else if (response.status === 200) {
        setSuccess(true);
        setFormData({
          contact_names: "",
          contact_email: "",
          contact_phone: "",
          contact_message: "",
        });
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setApiError(
        "Something went wrong. Please try again later or contact us directly."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="col-md-6">
      <h3>Get in touch</h3>
      {success && (
        <div
          className="alert alert-success d-flex align-items-center"
          role="alert"
        >
          <i className="bi bi-check-circle-fill me-2"></i>
          <div>
            We received your message and you'll hear from us soon. Thank You!
          </div>
        </div>
      )}
      {validationError && (
        <div
          className="alert alert-danger d-flex align-items-center"
          role="alert"
        >
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          <div>{validationError}</div>
        </div>
      )}
      {apiError && (
        <div
          className="alert alert-danger d-flex align-items-center"
          role="alert"
        >
          <i className="bi bi-exclamation-triangle-fill me-2"></i>
          <div>{apiError}</div>
        </div>
      )}
      <form id="contact-form" className="contact" onSubmit={handleSubmit}>
        <input
          className={`contact-input white-input ${
            error.contact_names ? "is-invalid" : ""
          }`}
          name="contact_names"
          placeholder="Full Name*"
          type="text"
          value={formData.contact_names}
          onChange={handleChange}
        />

        <input
          className={`contact-input white-input ${
            error.contact_email ? "is-invalid" : ""
          }`}
          name="contact_email"
          placeholder="Email Address*"
          type="email"
          value={formData.contact_email}
          onChange={handleChange}
        />

        <input
          className={`contact-input white-input ${
            error.contact_phone ? "is-invalid" : ""
          }`}
          name="contact_phone"
          placeholder="Phone Number*"
          type="text"
          value={formData.contact_phone}
          onChange={handleChange}
        />

        <textarea
          className={`contact-commnent white-input ${
            error.contact_message ? "is-invalid" : ""
          }`}
          rows={2}
          cols={20}
          name="contact_message"
          placeholder="Your Message..."
          value={formData.contact_message}
          onChange={handleChange}
        />

        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Sending...
            </>
          ) : (
            "Send Message"
          )}
        </button>
      </form>
    </div>
  );
}

export default ContactForm;
